export default __webpack_public_path__ + "static/media/global_example.852e7887.pdf";